import React from "react"
import Widget from "./components/Widget"
import ReactDOM from "react-dom"
import { ConfigContextData, ConfigProvider } from "./contexts/ConfigContext"
import { CustomerProvider } from "./contexts/CustomerContext"
import ShadowWrapper from "./components/ShadowWrapper"

const Happi = {
  init(config: ConfigContextData) {
    let el = document.createElement("div")

    const existingEl = document.querySelector<HTMLDivElement>("#happi-team-widget-root")
    if (existingEl) {
      el = existingEl
    } else {
      el.id = "happi-team-widget-root"

      if (document.body) {
        document.body.appendChild(el)
      } else {
        addEventListener("DOMContentLoaded", () => {
          document.body.appendChild(el)
        })
      }
    }

    ReactDOM.render(
      (
        <ShadowWrapper stylesheetUrl={config.stylesheetUrl}>
          <ConfigProvider value={config}>
            <CustomerProvider>
                <Widget />
            </CustomerProvider>
          </ConfigProvider>
        </ShadowWrapper>
      ),
      el
    )
  }
}

export default Happi
